import React, { useState, useMemo } from 'react';

function QuickAdd({ courses, onAddCourse, listType, listName }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [showResults, setShowResults] = useState(false);

  // Filter courses based on search term
  const filteredCourses = useMemo(() => {
    if (!searchTerm.trim()) return [];
    
    const term = searchTerm.toLowerCase();
    return courses
      .filter(course => 
        course.name.toLowerCase().includes(term) ||
        course.club_name?.toLowerCase().includes(term) ||
        course.city?.toLowerCase().includes(term) ||
        course.state?.toLowerCase().includes(term)
      )
      .slice(0, 10); // Limit to 10 results
  }, [searchTerm, courses]);

  const handleCourseSelect = (course) => {
    onAddCourse(course.course_id, listType);
    setSearchTerm('');
    setShowResults(false);
  };

  const handleInputFocus = () => {
    if (searchTerm.trim()) {
      setShowResults(true);
    }
  };

  const handleInputBlur = () => {
    // Delay hiding results to allow for clicks
    setTimeout(() => setShowResults(false), 200);
  };

  return (
    <div style={{ position: 'relative', marginBottom: '16px' }}>
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <input
          type="text"
          placeholder={`Search for courses to add to ${listName}...`}
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setShowResults(e.target.value.trim().length > 0);
          }}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          style={{
            flex: 1,
            padding: '8px 12px',
            border: '1px solid #ddd',
            borderRadius: '6px',
            fontSize: '14px',
            outline: 'none'
          }}
        />
        {searchTerm && (
          <button
            onClick={() => {
              setSearchTerm('');
              setShowResults(false);
            }}
            style={{
              background: '#f0f0f0',
              border: 'none',
              borderRadius: '4px',
              padding: '8px',
              cursor: 'pointer',
              fontSize: '16px',
              color: '#666'
            }}
          >
            ×
          </button>
        )}
      </div>

      {/* Search Results Dropdown */}
      {showResults && filteredCourses.length > 0 && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: 'white',
          border: '1px solid #ddd',
          borderRadius: '6px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          zIndex: 1000,
          maxHeight: '300px',
          overflowY: 'auto'
        }}>
          {filteredCourses.map(course => (
            <div
              key={course.course_id}
              onClick={() => handleCourseSelect(course)}
              style={{
                padding: '12px',
                borderBottom: '1px solid #f0f0f0',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f8f8'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
            >
              <div style={{ fontWeight: '600', color: '#222', marginBottom: '4px' }}>
                {course.name}
              </div>
              <div style={{ fontSize: '13px', color: '#666' }}>
                {course.club_name ? `${course.club_name} • ` : ''}{course.city}{course.city && course.state ? ', ' : ''}{course.state}
              </div>
              {/* Show rankings if available */}
              {(course.GD100all_rank || course.GD100pub_rank || course.top100_state_rank) && (
                <div style={{ fontSize: '12px', color: '#1D665D', fontWeight: '500', marginTop: '4px' }}>
                  {course.GD100all_rank && course.GD100all_rank !== '' ? `#${course.GD100all_rank} in America` : null}
                  {course.GD100pub_rank && course.GD100pub_rank !== '' ? (course.GD100all_rank && course.GD100all_rank !== '' ? ` • #${course.GD100pub_rank} Public in America` : `#${course.GD100pub_rank} Public in America`) : null}
                  {course.top100_state_rank > 0 && course.state ? ((course.GD100all_rank && course.GD100all_rank !== '') || (course.GD100pub_rank && course.GD100pub_rank !== '') ? ` • #${course.top100_state_rank} in ${course.state}` : `#${course.top100_state_rank} in ${course.state}`) : null}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* No Results Message */}
      {showResults && searchTerm.trim() && filteredCourses.length === 0 && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: 'white',
          border: '1px solid #ddd',
          borderRadius: '6px',
          padding: '12px',
          textAlign: 'center',
          color: '#666',
          fontSize: '14px',
          zIndex: 1000
        }}>
          No courses found matching "{searchTerm}"
        </div>
      )}
    </div>
  );
}

export default QuickAdd;
